<template>
  <div class="longTextWings"  :class="{'longTextWings--show':show}">
    {{shortText}}<template v-if="show">{{hideText}}</template>
    <button v-if="isLong" @click="show=!show"
            class="md-button-clean color-primary fwb longTextWings__button"
            :class="{'longTextWings__button--show':show}"
    >
      {{buttonText}}
    </button>
  </div>
</template>

<script>
export default {
  name: "longTextWings",
  props:{
    text:{},
    maxSymbols:{default:70},
  },
  data(){return{
    show:false,
  }},
  computed:{
    shortText(){
      let text = this.text;
      if (!text) return text;
      text = text.slice(0, this.maxSymbols);
      return text
    },
    hideText(){
      let text = this.text;
      if (!text) return;
      text = text.slice(this.maxSymbols);
      return text
    },
    isLong(){
      if (!this.text) return;
      return this.text.length > this.shortText.length
    },
    buttonText(){
      return this.show ?'скрыть':'...'
    }
  }
}
</script>

<style lang="scss">
.longTextWings{
  position: relative;
  padding-right: 20px;
  &--show{
    padding-bottom: 15px;
  }
}
.longTextWings__button{
  font-weight: bold !important;
  font-size: 1.2em;
  transition: none;
  border-bottom: 1px solid;
  padding-bottom: 1px;
  margin-left: 5px;
  line-height: 0.8;
  cursor: pointer;
  &--show{
    position: absolute;
    bottom: 0;
    right: 0;
    font-size: 0.9em;
    font-weight: normal !important;
  }
}
</style>
